import { useMutation, UseMutationResult } from 'react-query';
import { ResetPasswordDto, UserProfileApi } from '../../../api-client';
import { UseMutationOptions } from 'react-query/types/react/types';
import { AxiosResponse } from 'axios';
import { ErrorResponse } from '../../../common/types/errorRespose';

type UseResetOwnPassword = (
  userProfileApi: UserProfileApi,
  options?: Omit<
    UseMutationOptions<AxiosResponse<void>, ErrorResponse, ResetPasswordDto>,
    'mutationFn'
  >,
) => UseMutationResult<AxiosResponse<void>, ErrorResponse, ResetPasswordDto>;

export const useResetOwnPassword: UseResetOwnPassword = (
  userProfileApi: UserProfileApi,
  options,
) => {
  const tenantId = localStorage.getItem('tenantId') as string;
  return useMutation(
    (resetPasswordDto: ResetPasswordDto) =>
      userProfileApi.resetOwnPassword(tenantId, resetPasswordDto),
    options,
  );
};
